import { paymentStatementApi } from './base';

export type RetentionPeriod =
	| '1_day'
	| '1_week'
	| '1_month'
	| '2_months'
	| '3_months'
	| '12_months'
	| '24_months';

export type RetentionMode = 'keep_audit_record' | 'delete_everything';

/** Both null: the tenant keeps every statement. */
export interface DataRetentionSetting {
	period: RetentionPeriod | null;
	mode: RetentionMode | null;
}

export const dataRetentionApi = paymentStatementApi.injectEndpoints({
	endpoints: (builder) => ({
		getDataRetention: builder.query<DataRetentionSetting, void>({
			query: () => '/enterprise-settings/data-retention',
			providesTags: ['EnterpriseSettings'],
		}),
		updateDataRetention: builder.mutation<
			DataRetentionSetting,
			DataRetentionSetting
		>({
			query: (body) => ({
				url: '/enterprise-settings/data-retention',
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['EnterpriseSettings'],
		}),
	}),
});

export const { useGetDataRetentionQuery, useUpdateDataRetentionMutation } =
	dataRetentionApi;
